<div class="table" [nbSpinner]="isLoading">
  @if(selectedRow.size === 0) {

  <div class="global-actions">
    <div class="table-title">{{ title }}</div>
    <div class="actions">
      @for (a of globalActions; track $index; let i = $index) {

      <button
        nbButton
        status="primary"
        size="small"
        [alAnchor]="a.key ? 'tableaction.' + a.key : null"
        (click)="onGloablActionClick(a)"
      >
        <nb-icon [icon]="a.icon"></nb-icon> {{ a.title }}
      </button>

      }
    </div>
  </div>

  }@else{
  <div class="multi-actions">
    <button
      nbButton
      ghost
      size="small"
      (click)="deselectAll()"
      class="multi-action-btn"
      type="button"
      [nbTooltip]="'popovers.deselectAll' | translate"
      nbTooltipPlacement="top"
    >
      <nb-icon icon="close-outline"></nb-icon>
    </button>
    <div class="selected-text">
      {{ selectedRow.size }} {{ "components.table.selected" | translate }}
      @if (selectionSummaryText) {
      <span class="selection-summary">· {{ selectionSummaryText }}</span>
      }
    </div>

    @for (a of rowActions; track trackAction(i, a); let i = $index) { @if(a.isMultiAction){

    <button
      nbButton
      ghost
      size="small"
      class="multi-action-btn"
      type="button"
      [disabled]="a.disabled === true"
      [attr.aria-label]="a.title"
      (click)="onMultiActionClick(a)"
      [nbTooltip]="a.title"
      nbTooltipPlacement="top"
    >
      <nb-icon [icon]="a.icon"></nb-icon>
    </button>
    } }
  </div>
  }

  <!-- Waagerechter Scrollbereich (CI `.al-table-scroll`): wird die Karte
       schmaler als die Tabelle, scrollt sie hier drin, statt Spalten auf
       ein Zeichen zusammenzudrücken. -->
  <div class="table-scroll">
  <table>
    <thead>
      <tr>
        <th class="checkbox-cell" *ngIf="selectable">
          <div class="cell-content">
            <nb-checkbox
              [checked]="isSelectAllChecked"
              (checkedChange)="onCheckBoxChange($event)"
            ></nb-checkbox>
          </div>
        </th>
        <th
          *ngFor="let column of columns; trackBy: trackColumn"
          width="{{ column?.width }}"
          [class.cell--numeric]="isNumeric(column)"
          [class.cell--name]="isName(column)"
          [class.cell--text]="isText(column)"
        >
          <div class="cell-content" (click)="onSort(column)">
            {{ column.title }}

            <nb-icon
              *ngIf="
                sortingDirection !== 'none' && sortingColumn?.key === column.key
              "
              [icon]="
                sortingDirection === 'asc'
                  ? 'chevron-up-outline'
                  : 'chevron-down-outline'
              "
            ></nb-icon>
          </div>
        </th>
        <th class="action-cell" *ngIf="rowActions.length > 0"></th>
      </tr>
    </thead>
    <tbody>
      <tr
        *ngFor="let row of finalData; trackBy: trackRow"
        [class.has-open-menu]="isRowMenuOpen(row)"
        [agentTarget]="agentEntityType ? [agentEntityType, row[rowIdKey], 'row'] : null"
      >
        <td class="checkbox-cell" *ngIf="selectable">
          <div class="cell-content">
            <nb-checkbox
              checked="{{ selectedRow.has(row[this.rowIdKey]) }}"
              (checkedChange)="onCheckBoxChange($event, row[this.rowIdKey])"
            ></nb-checkbox>
          </div>
        </td>
        <td
          *ngFor="let column of columns; trackBy: trackColumn"
          [class.cell--numeric]="isNumeric(column)"
          [class.cell--name]="isName(column)"
          [class.cell--text]="isText(column)"
        >
          <div class="cell-content">
            @if(column.component) {

            <ng-container
              [appTableDynamicCell]="column.component"
              [appTableDynamicCellInputs]="resolveComponentInputs(column, row)"
            ></ng-container>

            }@else{

            {{ mapValue(row[column.key], row, column.map) }}

            }
          </div>
        </td>
        <td class="action-cell" *ngIf="rowActions.length > 0">
          <div class="cell-content row-action-wrapper">
            <button
              type="button"
              class="row-action-trigger"
              cdkOverlayOrigin
              #rowMenuOrigin="cdkOverlayOrigin"
              [class.is-open]="isRowMenuOpen(row)"
              (click)="toggleRowMenu($event, row)"
            >
              <nb-icon icon="more-vertical-outline"></nb-icon>
            </button>
            <!-- Im Overlay, nicht in der Zelle — siehe rowMenuPositions. -->
            <ng-template
              cdkConnectedOverlay
              #rowMenuOverlay="cdkConnectedOverlay"
              [cdkConnectedOverlayOrigin]="rowMenuOrigin"
              [cdkConnectedOverlayOpen]="isRowMenuOpen(row)"
              [cdkConnectedOverlayPositions]="rowMenuPositions"
              (attach)="onRowMenuAttached(rowMenuOverlay)"
              (detach)="onRowMenuDetached(row, rowMenuOrigin)"
            >
            <div
              class="row-action-menu"
              (click)="$event.stopPropagation()"
            >
              <button
                *ngFor="let action of getRowActions(row); trackBy: trackAction"
                type="button"
                class="row-action-item"
                [class.is-disabled]="action.disabled"
                [attr.aria-disabled]="action.disabled"
                [attr.title]="action.data?.tooltip || null"
                (click)="onRowMenuActionClick($event, action, row)"
              >
                <nb-icon [icon]="action.icon"></nb-icon>
                <span>{{ action.title }}</span>
              </button>
            </div>
            </ng-template>
          </div>
        </td>
      </tr>

      <tr *ngIf="data.length === 0">
        <td [attr.colspan]="columns.length + (selectable ? 2 : 1)" class="empty-cell">
          <div class="cell-content isEmpty">
            {{ "components.table.noResults" | translate }}
          </div>
        </td>
      </tr>
    </tbody>
  </table>
  </div>
  <app-pagination
    *ngIf="showPagination"
    [totalItems]="data.length"
    [itemsPerPage]="maxVisibleItems"
    [currentPage]="currentPage"
    (pageChanged)="onPageChanged($event)"
    (itemsPerPageChange)="onItemsPerPageChange($event)"
  ></app-pagination>
</div>
